import { gql } from '@apollo/client'

export const CHANGE_DEPARTMENT = gql`
  mutation ChangeDepartment($input: DepartmentInput!) {
    changeDepartment(input: $input) {
      department_id
      name
      description
    }
  }
`

export const REMOVE_DEPARTMENT = gql`
  mutation RemoveDepartment($department_id: Int!) {
    removeDepartment(department_id: $department_id) {
      department_id
    }
  }
`
